import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { dispatch } from 'store'
import { getIsScrollAtBottom } from 'containers/SubSidebar/AiImageContent/HistoryTab/utils'
import { useEventListener } from 'hooks'
import { FETCH_LIMIT } from 'containers/SubSidebar/AIVideoContent/consts'
import debounce from 'lodash.debounce'

const SCROLL_DEBOUNCE_DELAY = 300

export const useFetchAIVideoHistoryOnScroll = (
  containerRef: HTMLElement | null
) => {
  const isLoading = useSelector(aiVideoSelectors.isHistoryListLoading)
  const currentOffset = useSelector(aiVideoSelectors.aiVideoHistoryRawOffset)
  const totalCount = useSelector(aiVideoSelectors.aiVideoHistoryTotalCount)

  const fetchMoreData = useCallback(() => {
    if (!containerRef || isLoading) return

    const hasMoreItems = currentOffset < totalCount
    if (!hasMoreItems) return

    const isAtBottom = getIsScrollAtBottom(containerRef)

    if (isAtBottom) {
      dispatch(
        aiVideoThunks.getAIVideoHistory({
          offset: currentOffset,
          limit: FETCH_LIMIT
        })
      )
    }
  }, [containerRef, isLoading, currentOffset, totalCount])

  const debouncedFetchMoreData = useMemo(
    () => debounce(fetchMoreData, SCROLL_DEBOUNCE_DELAY),
    [fetchMoreData]
  )

  useEventListener('scroll', debouncedFetchMoreData, containerRef)
}
